import React from "react";
import useMobile from "../../hooks/useMobile";
import useTab from "../../hooks/useTab";

const UserFilters = () => {
  const isMobile = useMobile();
  const isTab = useTab();
  return (
    <div
      className={`py-2 mb-3 d-flex gap-2 flex-wrap ${isMobile || isTab ? "justify-content-end" : "justify-content-between"}`}
    >
      <div className="search">
        <input className="form-control" placeholder="Search User by Name, Email, Roles" />
      </div>
    </div>
  );
};

export default UserFilters;
